<template>
  <modal
    title="Ajouter un concept"
    large
    :value="value"
    @input="$emit('input', $event)"
    @ok="handleNewConcept()"
    effect="fade/zoom"
  >
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">Ajouter un concept</h4>
    </div>

    <div class="form-group has-danger">
      <label>Nom</label>
      <input
        v-model="form.name"
        type="text"
        class="form-control"
        placeholder="exemple : justcoaching.fr"
      />
    </div>

    <div class="form-group">
      <label>Description</label>
      <textarea
        v-model="form.description"
        rows="2"
        class="form-control"
      ></textarea>
    </div>

    <div class="form-group">
      <label>Logo</label>
      <dropzone
        id="file"
        :url="apiUploads()"
        :headers="apiAuthorization()"
        @vdropzone-success="fileUploaded"
        @vdropzone-sending="addParamsToDropzoneRequest"
      >
        <div class="dz-default dz-message">
          <span
            ><i class="icon-cloud-upload"></i><br />Glissez l'image ici</span
          >
        </div>
      </dropzone>
    </div>
  </modal>
</template>
<style type="text/css">
.icon-cloud-upload {
  font-size: 40px;
}
</style>

<script>
import axios from "axios";
import Modal from "vue-strap/src/Modal";
import Dropzone from "vue2-dropzone";

export default {
  components: {
    Modal,
    Dropzone,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        name: null,
        logo: null,
        description: null,
      },
    };
  },

  methods: {
    apiUploads() {
      return axios.defaults.baseURL + "uploads";
    },

    apiAuthorization() {
      return {
        Authorization: localStorage.getItem("token"),
      };
    },

    fileUploaded(file, response) {
      this.form.logo = response.id;
    },

    async handleNewConcept() {
      if (!this.form.name) {
        return false;
      }

      try {
        const { data } = await this.$api.post("/concepts", this.form);

        this.$emit("input", false);
        this.$emit("created", data);
      } catch {
        this.$errorToast("Erreur lors de la création du concept");
      }
    },

    addParamsToDropzoneRequest(file, xhr, formData) {
      formData.append("folder", "concepts");
    },
  },
};
</script>
